module.exports = __webpack_public_path__ + "static/aditya_mehrotra-8da62a00217ad3f06d9b1d31491ca355.jpeg";